export default __webpack_public_path__ + "static/media/background.735eb809.png";